import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';
import styles from './index.css';
import { h5PageCount } from 'ThreeTerminal_utils';
import InfoTitle from '../infoTitle';

class ThreeImg extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    onClick = (url, clickCount) => {
        h5PageCount([clickCount]);

        window.location.href = url;
    };

    render() {
        const { content } = this.props;

        const {
            images,
            weburl,
            clickCount,
            comment_contents,
            share_url,
            isOnClickDocTitle,
            isCallNewApp,
            isComment,
            pageInfo,
            doc_name,
            sub_name,
            nickname,
        } = content;

        const infoTitleData = {
            comment_contents,
            share_url,
            isOnClickDocTitle,
            isCallNewApp,
            isComment,
            pageInfo,
            sub_name,
            nickname,
        };

        // let images = [
        //     'http://d.ifengimg.com/mw640_q75/p1.ifengimg.com/cmpp/2018/07/19/06/14832598-84e7-42e5-96ed-2a7f43a785e9_size610_w1066_h1065.png',
        //     'http://d.ifengimg.com/mw640_q75/p3.ifengimg.com/cmpp/2018/07/19/06/c13af161-24f7-4170-9ee5-4832769e26b7_size825_w1061_h1061.png',
        //     'http://d.ifengimg.com/mw640_q75/p0.ifengimg.com/cmpp/2018/07/19/06/71b58ae6-02fb-40c6-87ba-a0deec11d571_size904_w1069_h906.png',
        //     'http://d.ifengimg.com/mw640_q75/p0.ifengimg.com/cmpp/2018/07/19/06/71b58ae6-02fb-40c6-87ba-a0deec11d571_size904_w1069_h906.png',
        //     // "http://d.ifengimg.com/mw640_q75/p1.ifengimg.com/cmpp/2018/07/19/06/14832598-84e7-42e5-96ed-2a7f43a785e9_size610_w1066_h1065.png",
        //     // "http://d.ifengimg.com/mw640_q75/p3.ifengimg.com/cmpp/2018/07/19/06/c13af161-24f7-4170-9ee5-4832769e26b7_size825_w1061_h1061.png",
        //     // "http://d.ifengimg.com/mw640_q75/p0.ifengimg.com/cmpp/2018/07/19/06/71b58ae6-02fb-40c6-87ba-a0deec11d571_size904_w1069_h906.png",
        // ];

        // 最多9条
        const imgs = images.slice(0, 9);
        const len = imgs.length;

        return (
            <React.Fragment>
                <InfoTitle content={infoTitleData} />
                <div className={styles.video_briefs} onClick={() => this.onClick(weburl, clickCount)}>
                    <p>
                        {sub_name && <span className={styles.source}>@{sub_name}: </span>}
                        {doc_name}
                    </p>
                    <div className={len === 4 ? styles.pic_large : styles.three_pic}>
                        <ul>
                            {imgs.map((item, index) => (
                                <li
                                    key={index}
                                    className={(index + 1) % 3 === 0 && len !== 4 ? styles.mr0 : styles.imgs}>
                                    <img
                                        className={len >= 4 ? styles.big_img : styles.small_img}
                                        src={len >= 4 ? formatImage(item, 115, 115) : formatImage(item, 115, 76)}
                                    />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default errorBoundary(ThreeImg);
